import React from "react";
import { Grid, Button, Typography,	makeStyles,} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewTwoToneIcon from "@mui/icons-material/ArrowBackIosNewTwoTone";


const useStyles = makeStyles(() => ({
	Typography: {
        padding: "1rem", textAlign: "justify",    lineHeight:"normal" 
	},
	
}));

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const classes = useStyles();
  return (
    <Grid style={{ background: "#f1f1f1", height: "100vh" }}>
      <Grid
        style={{
          padding: "0.8rem",
          boxShadow: "0px 0px 9px",
          background: "white",
        }}
      >
        <Button
          onClick={() => {
            navigate(-1);
          }}
          style={{
            position: "absolute",
            left: 0,
          }}
        >
          <ArrowBackIosNewTwoToneIcon />
        </Button>
        <Typography variant="h5" style={{ fontWeight: "bold" }}>
          Privacy Policy
        </Typography>
      </Grid>
      <Grid style={{ padding: "1rem", marginTop: "1rem" ,maxHeight:"85vh",overflow:"scroll",scrollbarWidth:"none" }} >
        <Typography className={classes.Typography}>
            
          We value the trust you place in us. That's why we insist upon the
          highest standards for secure transactions and customer information
          privacy. Please read the following statement to learn about our
          information gathering and dissemination practices.
        </Typography>

        <Typography>
          <Typography className={classes.Typography}>
              
            We value the trust you place in us. That's why we insist upon the
            highest standards for secure transactions and customer information
            privacy. Please read the following statement to learn about our
            information gathering and dissemination practices.  
          </Typography>

          <Typography className={classes.Typography}>
            Our privacy policy is subject to change at any time without notice.
            To make sure you are aware of any changes, please review this policy
            periodically.
          </Typography>

          <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
              
            By visiting this Platform you agree to be bound by the terms and
            conditions of this Privacy Policy. If you do not agree please do not
            use or access our Platform.
          </Typography>

          <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
            By mere use of the Platform, you expressly consent to our use and
            disclosure of personal information provided by you in accordance
            with this Privacy Policy. This Privacy Policy is incorporated into
            and subject to the Terms of Use.
          </Typography>

          <Typography className={classes.Typography}  style={{fontWeight:"bold",paddingBottom:"0rem"}}>
              
            Collection of Personally Identifiable Information and other
            Information
          </Typography>

          <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
            When you use our Platform, we collect and store your personal
            information which is provided by you from time to time. Our primary
            goal in doing so is to provide you a safe, efficient, smooth and
            customized experience. This allows us to provide services and
            features that most likely meet your needs, and to  
            customize our Platform to make your experience safer and easier.
            More importantly, while doing so we collect personal information
            from you that we consider necessary for achieving this purpose.
          </Typography>

         

          <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
              
            In general, you can browse the Platform without telling us who you
            are or revealing any personal information about yourself. Once you
            give us your personal information, you are not anonymous to us.
            Where possible, we indicate which fields are required and which
            fields are optional. You always have the option to not provide
            information by choosing not to use a particular service or feature
            on the Platform. We may automatically track certain information
            about you based upon your behaviour on our Platform. We use this
            information to do internal research on our users' demographics,
            interests, and behaviour to better understand, protect and serve our
            users. This information is compiled and analysed on an aggregated
            basis. This information may include the URL that you just came from
            (whether this URL is on our Website or not), which URL you next go
            to (whether this URL is on our Website or not), your computer
            browser information, and your IP address. 
          </Typography>

          <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
              
            We use data collection devices such as 'cookies' on certain pages of
            the Website to help analyse our web page flow, measure promotional
            effectiveness, and promote trust and safety. 'Cookies' are small
            files placed on your hard drive that assist us in providing our
            services. We offer certain features that are only available through
            the use of a 'cookie'. Cookies can also help us provide information
            that is targeted to your interests. Most cookies are 'session
            cookies,' meaning that they are automatically deleted from your hard
            drive at the end of a session. You are always free to decline our
            cookies if your browser permits, although in that case you may not
            be able to use certain features on the Platform.
          </Typography>

          <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
              
            Additionally, you may encounter 'cookies' or other similar devices
            on certain pages of the Platform that are placed by third parties.
            We do not control the use of cookies by third parties.  
          </Typography>

          <Typography className={classes.Typography}>
              
            If you choose to buy on the Platform, we collect information about
            your buying behaviour, preferences, and other such information that
            you choose to provide. 
          </Typography>

          <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
              
            If you choose to buy on the Platform, we collect information about
            your buying behaviour, preferences, and other such information that
            you choose to provide.
            <ul className="document-ul3">
              <li className="mb-2">
               <Typography> We collect some additional information, such as a name, mobile
                number and delivery location. </Typography>  
              </li>
              <li> <Typography>
                We use third party end to end payment gateway solution and we DO
                NOT collect/save information, such as a billing address, a
                credit / debit card number and a credit / debit card expiration
                date and/ or other payment instrument details in our Platform.   </Typography>  
              </li>
            </ul>
            <Typography className={classes.Typography}  style={{fontWeight:"bold",paddingBottom:"0rem"}}>
                
              Use of Demographic / Profile Data / Your Information  
            </Typography>
            <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
                
              We use personal information to provide the services you request.
              To the extent we use your personal information to market to you,
              we will provide you the ability to opt-out of such uses. We use
              your personal information to assist sellers in handling and
              fulfilling orders, enhancing customer experience, resolve
              disputes; troubleshoot problems; help promote a safe service;
              collect money; measure consumer interest in our products and
              services, inform you about online and offline offers, products,
              services, and updates; customize and enhance your experience;
              detect and protect us against error, fraud and other criminal
              activity; enforce our terms and conditions; and as otherwise
              described to you at the time of collection.
            </Typography>
            <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
                
              In our efforts to continually improve our product and service
              offerings, we and our affiliates collect and analyse demographic
              and profile data about our users' activity on our Website.  
            </Typography>
            <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
                
              We identify and use your IP address to help diagnose problems with
              our server, and to administer our Platform. Your IP address is
              also used to help identify you and to gather broad demographic
              information.
            </Typography>
            <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
                
              We identify and use your IP address to help diagnose problems with
              our server, and to administer our Platform. Your IP address is
              also used to help identify you and to gather broad demographic
              information. 
            </Typography>
            <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
                
              We will occasionally ask you to complete optional online surveys.
              These surveys may ask you for personal information, contact
              information, date of birth, demographic information (like zip
              code, age, or income level), attributes such as your interests,
              household or lifestyle information, your purchasing behaviour or
              history, preferences, and other such information that you may
              choose to provide.. We use this data to tailor your experience at
              our Website, providing you with content that we think you might be
              interested in and to display content according to your
              preferences. 
            </Typography>
            <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
                
              A 'cookie' is a small piece of information stored by a web server
              on a web browser so it can be later read back from that browser.
              Cookies are useful for enabling the browser to remember
              information specific to a given user. We place both permanent and
              temporary cookies in your computer's hard drive. The cookies do
              not contain any of your personally identifiable information.  
            </Typography>
            <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
                
              We may share personal information with our other corporate
              entities and affiliates. These entities and affiliates may market
              to you as a result of such sharing unless you explicitly opt-out."  
            </Typography>
            <Typography className={classes.Typography}>
                
              We may disclose personal information to third parties. This
              disclosure may be required for us to provide you access to our
              Services, or for enhancing your experience, or to comply with our
              legal obligations, to enforce our User Agreement, to facilitate
              our marketing and advertising activities, or to prevent, detect,
              mitigate, and investigate fraudulent or illegal activities related
              to our Services. We do not disclose your personal information to
              third parties for their marketing and advertising purposes without
              your explicit consent.  
            </Typography>
            <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
              We may disclose personal information if required to do so by law
              or in the good faith belief that such disclosure is reasonably
              necessary to respond to subpoenas, court orders, or other legal
              process. We may disclose personal information to law enforcement
              offices, third party rights owners, or others in the good faith
              belief that such disclosure is reasonably necessary to: enforce
              our Terms or Privacy Policy; respond to claims that an
              advertisement, posting or other content violates the rights of a
              third party; or protect the rights, property or personal safety of
              our users or the general public. 
            </Typography>
            We and our affiliates will share some or all of your personal
            information with another business entity basis we (or our assets)
            plan to merge with, or be acquired by that business entity, or
            re-organization, amalgamation, restructuring of business. Should
            such a transaction occur that other business entity (or the new
            combined entity) will be required to follow this privacy policy with
            respect to your personal information.  
          </Typography>

          <Typography  className={classes.Typography}  style={{fontWeight:"bold",paddingBottom:"0rem"}} >
              
            Your Consent 
          </Typography>
          <Typography className={classes.Typography}>
              
            By using the Platform and/ or by providing your information, you
            consent to the collection and use of the information you disclose on
            the Platform in accordance with this Privacy Policy, including but
            not limited to Your consent for sharing your information as per this
            privacy policy. If you disclose any personal information relating to
            other people to us, you represent that you have the authority to do
            so and to permit us to use the information in accordance with this
            Privacy Policy.  
          </Typography>

          <Typography style={{ padding: "1rem", textAlign: "justify" ,    lineHeight:"normal" }}>
              
            If we decide to change our privacy policy, we will post those
            changes on this page so that you are always aware of what
            information we collect, how we use it, and under what circumstances
            we disclose it. 
          </Typography>
        </Typography>
      </Grid>
    </Grid>
  );
}
